import { inject } from 'mobx-react';
import Project from '@extensions/models/Project';
import ReferencesPanel from '@extensions/components/core/ReferencesPanel';
import { ProjectOverview as DapProjectOverview } from '@dapclient/components/project/ProjectOverview';

export class ProjectOverview extends DapProjectOverview {
  getReferencesPanel = (project: Project): JSX.Element | React.ReactNode | null => {
    return <ReferencesPanel project={project} />
  };
}

export default inject((store: any) => ({
  projectService: store.projectService,
  datasetService: store.datasetService,
  metricsService: store.metricsService,
  securityService: store.securityService,
  notificationService: store.notificationService,
}))(ProjectOverview);
